<template>
  <div
    v-if="milestonesList"
    id="milestones-list-wrapper"
    class="d-flex flex-column p-4 milestone-wrapper"
  >
    <h2 class="my-2">
      Rank Milestones
    </h2>
    <span class="mb-4">Complete Missions & Claim Your Points to Get These Cool Badges!</span>
    <div
      v-for="(milestone, index) in milestonesList"
      :key="milestone.name"
      class="milestone-item"
      @click="expandMilestone(milestone, index)"
    >
      <div class="d-flex align-items-center w-100">
        <div :class="{ 'image-wrapper': !milestone.image }">
          <img
            v-if="milestone.image"
            class="mr-4 rounded"
            :src="milestone.image"
            width="120"
            height="120"
          >
        </div>
        <div class="d-flex flex-column flex-grow-1">
          <span class="milestone-name">{{ milestone.name }}</span>
          <span>{{ milestone.earnMessage }}</span>
        </div>
        <img
          src="@/images/right-chevron.png"
          alt="arrow"
          class="arrow"
          :class="{'expand': selectedIndex === index}"
          width="20"
          height="20"
        >
      </div>
      <!----Expandable---->
      <div
        v-if="selectedIndex === index"
        class="d-flex w-100 flex-column px-3"
      >
        <h5 class="my-3">
          Unlockables:
        </h5>
        <div
          v-for="unlockable in milestone.unlockables"
          :key="unlockable.name"
        >
          <div :class="!unlockable.listingImage && 'image-wrapper' ">
            <img
              v-if="unlockable.listingImage"
              class="mr-4 rounded"
              :src="unlockable.listingImage"
              width="60"
              height="60"
            >
          </div>
          <div class="d-flex align-items-center mr-4 my-4">
            <div
              id="point-icon"
              class="point-icon"
            >
              P
            </div>
            <span>{{ milestone.experienceRequired }}</span>
          </div>
        </div>
      </div>
      <!----Expandable---->
    </div>

    <div class="d-flex flex-column flex-grow-1 justify-content-center align-items-center mt-4">
      <VsButton
        class="go-to-btn"
        @click="goTo('missions')"
      >
        Complete Mission to Unlock!
      </VsButton>
    </div>
  </div>
  <div
    v-else
    class="p-6 text-center"
  >
    Loading...
  </div>
</template>

<script lang="ts">

import Vue from 'vue';
import { Milestone } from '@viddsee/server-api-client/types/models/me/point-system';
import { meApi } from '@/scripts/webcall/v3/me';
import VsButton from '@/scripts/Components/Molecules/VsButton.vue';

export default Vue.extend({
  components: {
    VsButton,
  },

  data() {
    return {
      milestonesList: null as null | Array<Milestone>,
      selectedMilestone: null as null | Milestone,
      selectedIndex: null as null | number,
    };
  },
  async created() {
    await meApi.pointSystemApi.listMilestones().then((data) => {
      this.milestonesList = data.data.items;
    });
  },
  methods: {
    goTo(page: string): void {
      this.$emit('go-to', page);
    },
    expandMilestone(milestone: Milestone, index: number): void {
      if (this.selectedIndex === index) {
        this.selectedIndex = null;
      } else {
        this.selectedMilestone = milestone;
        this.selectedIndex = index;
        this.$modal.show('zoom-out-modal');
      }
    },
  },

});
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.milestone-wrapper {
  max-height: 800px;
  overflow-y: scroll;
}
.go-to-btn {
  height: 40px;
  padding: 12px 16px;
  font-size: 24px;
  font-weight: 700;
  background-color: $primary;
  color: white !important;
  border-radius: 4px;
  min-width: 50%;
  margin-bottom: 12px;
}
.milestone-name {
  font-weight: 700;
  font-size: 16px;
}
.milestone-item {
  flex-direction: column;
  display: flex;
  align-items: center;
  margin: 12px 0;
  padding: 4px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 4px 4px 8px 0px #00000033;
}
.image-wrapper {
  width: 120px;
  height: 120px;
  margin-right: 12px;
}
.expand {
  transform: rotate(90deg);
}
.arrow {
  margin: 0 8px 0 4px;
  transition: transform 0.5s ease-in-out;
}
.point-icon{
  background-color: $primary;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
}
</style>
